import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Button } from 'components/ui';
import { t, dangerousHTML } from 'utils';

import styles from './CreateAppFormStep.module.scss';

export interface IFormStep extends HTMLAttributes<HTMLDivElement> {
  stepNumber: number;
  maxSteps: number;
  title: string;
  description: string;
  submitting: boolean;
  component?: FC<any>;
  buttonText?: string;
  isInlineButton?: boolean;
  validate?: any;
  isValid?: boolean;
  values: any;
  stepMaxHeight: number;
  submitError: any;
  modifiedSinceLastSubmit: boolean;
}

const FormStep: FC<IFormStep> = (props) => {
  const {
    stepNumber,
    maxSteps,
    title,
    description,
    component: Component,
    buttonText,
    isInlineButton,
    submitting,
    isValid,
    className,
    values,
    stepMaxHeight,
    submitError,
    modifiedSinceLastSubmit,
  } = props;

  const rootClassName = classNames(styles.root, className);
  // const { isPublic } = values || {};
  const buttonClassName = classNames(styles.button, {
    // [styles['full-width']]: isPublic === 'yes' && title !== 'form.publicAppDetail.title',
  });

  return (
    <section className={rootClassName} style={{ maxHeight: `${stepMaxHeight}px` }}>
      {stepNumber > 0 && (
        <p className={styles.stepIndicator}>
          {stepNumber}/{maxSteps}
        </p>
      )}
      <h2 className={styles.heading}>{t('new.app.title')}</h2>
      <h3 className={styles.title}>{t(title)}</h3>
      <p className={styles.description}>
        <span dangerouslySetInnerHTML={{ __html: dangerousHTML(t(description), false, true) }} />
      </p>
      {Component && (
        <Component
          values={values}
          isValid={isValid}
          submitError={submitError}
          modifiedSinceLastSubmit={modifiedSinceLastSubmit}
        />
      )}
      {buttonText && (
        <Button
          className={buttonClassName}
          type='submit'
          inline={isInlineButton}
          disabled={submitting || !isValid || (submitError && !modifiedSinceLastSubmit)}
        >
          {t(buttonText)}
        </Button>
      )}
    </section>
  );
};

export default FormStep;
